<cfp-login-card [title]="'login.title' | translate">
  <cfp-login-loading-spinner [loading]="isLoading()" />

  @let changePasswordValue = changePassword();
  @let errorMessagesValue = errorMessages();
  @let warningMessagesValue = warningMessages();
  @let loginMessagesDataTestValue = loginMessagesDataTest();
  @let interpolateParamsValue = interpolateParams();
  @let showLoginAttemptsWarningValue = showLoginAttemptsWarning();
  @if (changePasswordValue) {
    <cfp-login-messages
      [errorMessages]="errorMessagesValue"
      [warningMessages]="warningMessagesValue"
      [attr.data-test]="loginMessagesDataTestValue"
      [interpolateParams]="interpolateParamsValue"
    />
    <cfp-button [buttonStyle]="'warning'" (clicked)="routePasswordChange()" [dataTest]="'goToChangePasswordButton'">
      {{ 'login.change' | translate }}
    </cfp-button>
  } @else {
    <form [formGroup]="form" #ngForm="ngForm">
      <cfp-form-group [label]="'login.userNameOrEmail' | translate">
        <cfp-input-text
          [dataTest]="'userName'"
          formControlName="username"
          autocomplete="email"
          [placeholder]="'login.userNameOrEmail.placeholder' | translate"
        />
        <cfp-validation-feedback
          [showMessage]="form.get('username')?.invalid === true && ngForm.submitted"
          [control]="form.get('username')"
        />
      </cfp-form-group>
      <cfp-form-group [label]="'login.password' | translate">
        <span class="float-end" formGroupActions>
          <cfp-link
            [style]="'link'"
            [route]="`${basePath}/auth/forgot`"
            [classes]="'p-0 xsmall'"
            [dataTest]="'forgotPasswordButton'"
          >
            {{ 'login.forgot' | translate }}
          </cfp-link>
        </span>
        <cfp-input-password
          formControlName="password"
          autocomplete="current-password"
          [placeholder]="'login.password.placeholder' | translate"
          [dataTest]="'password'"
        />
        <cfp-validation-feedback
          [showMessage]="form.get('password')?.invalid === true && ngForm.submitted"
          [control]="form.get('password')"
        />
      </cfp-form-group>

      <cfp-login-messages
        [errorMessages]="errorMessagesValue"
        [warningMessages]="warningMessagesValue"
        [attr.data-test]="loginMessagesDataTestValue"
        [interpolateParams]="interpolateParamsValue"
        [attr.data-test]="loginMessagesDataTestValue"
      />

      @if (showLoginAttemptsWarningValue) {
        <cfp-alert [alertStyle]="'warning'" [icon]="'info-circle'" [iconAriaLabel]="'Warning'" [hasAccent]="true">
          <p>{{ 'login.error.explainBlock' | translate }}</p>
          @if (environment.components.unlockAccount) {
            <a class="btn btn-block btn-warning" [routerLink]="basePath + '/auth/unlock'">
              {{ 'login.unlock' | translate }}
            </a>
          } @else {
            <button class="btn btn-block btn-warning" type="button" (click)="contactSupport()">
              {{ 'contact.support' | translate }}
            </button>
          }
        </cfp-alert>
      }

      <cfp-button
        class="mt-4 d-block"
        classes="d-flex w-100  align-items-center justify-content-center"
        [type]="'submit'"
        (clicked)="submitForm()"
        [dataTest]="'loginButton'"
      >
        {{ 'login.button' | translate }}
      </cfp-button>
      <cfp-login-sso />
      @if (loginAllowSelfOnboarding) {
        <div class="mt-4">
          <div class="mb-2">{{ 'login.noAccount' | translate }}</div>
          <cfp-link [route]="'/create-account'" [classes]="'w-100'" [buttonOutline]="true" [buttonStyle]="'secondary'">
            {{ 'login.createAccount' | translate }}
          </cfp-link>
        </div>
      }
      <ng-content />
    </form>
  }
</cfp-login-card>
